import React, { memo } from 'react';
import { MechanicalContractor } from './types';
import StatusPill from '../StatusPill';

interface MechanicalContractorBasicDetailsProps {
  contractor: MechanicalContractor;
  headOfficeAddress?: string;
}

const MechanicalContractorBasicDetails = memo(({
  contractor,
  headOfficeAddress
}: MechanicalContractorBasicDetailsProps) => {
  return (
    <div className="space-y-6">
      <div>
        <dt className="text-sm font-medium text-gray-900 mb-2">Head Office Address</dt>
        <dd className="text-sm text-gray-700">
          {headOfficeAddress || 'No address provided'}
        </dd>
      </div>

      <div>
        <dt className="text-sm font-medium text-gray-900 mb-2">Status</dt>
        <dd className="text-sm">
          <StatusPill status={contractor.status} />
        </dd>
      </div>
    </div>
  );
});

MechanicalContractorBasicDetails.displayName = 'MechanicalContractorBasicDetails';

export default MechanicalContractorBasicDetails;